<template>
  <div class="column">
    <div class="box">
      <h2 class="subtitle has-text-weight-bold">Contrapartidas</h2>

      <hr class="content-separator" />

      <p><b>Início do Projeto</b></p>

      <ul>
        <li>
          <p><b>&#8226; Prazo:</b> até 7 dias após o início do projeto</p>
        </li>

        <li>
          <p>
            <b>&#8226; Formulário:</b> Após a ação, enviar o formulário aos
            participantes para que possam compartilhar seus dados e comentários
            sobre a ação. O formulário será disponibilizado pela Empower.
          </p>
        </li>

        <li>
          <p>
            <b>&#8226; Post 1:</b> publicar pelo menos 1 post sobre a parceria
            para o projeto na fanpage, insta ou linkedin OE / Grupo de Pesquisa
            / Instituto de Pesquisa, incluindo os logos da Empower e
            {{ businessName }}
          </p>
        </li>
      </ul>

      <br />

      <p><b>Término do Projeto</b></p>

      <ul>
        <li>
          <p><b>&#8226; Prazo:</b> até 7 dias após o término do projeto</p>
        </li>

        <li>
          <p>
            <b>&#8226; Fotos:</b> enviar pelo menos 4 fotos sobre o projeto
            (equipe + resultados)
          </p>
        </li>

        <li>
          <p>
            <b>&#8226; Post 2:</b> publicar pelo menos 1 post sobre os
            resultados gerados pela parceria na fanpage, insta ou linkedin da OE
            / Grupo de Pesquisa / Instituto de Pesquisa, incluindo os logos da
            Empower e {{ businessName }}
          </p>
        </li>
      </ul>

      <br />

      <div class="has-text-centered">
        <a :href="logosZipURL" class="button is-empower-gray-2">
          Baixar Logos
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { responsive } from "../../../../mixins/responsive";

export default {
  props: ["businessName", "logosZipURL"],

  mixins: [responsive]
};
</script>

<style scoped>
.content-separator {
  background-color: rgb(211, 211, 211);
  height: 1px;
}
</style>
